import { defineMessages } from 'react-intl';

import { Skin } from '#src/__generated__/globalTypes.ts';

export const skinMessages = defineMessages<Skin>({
  [Skin.STANDARD]: {
    defaultMessage: 'Standard',
  },
  [Skin.SHINY]: {
    defaultMessage: 'Shiny',
  },
  [Skin.HOLO]: {
    defaultMessage: 'Holo',
  },
  [Skin.FULL_ART]: {
    defaultMessage: 'Legendary',
  },
});
